import React from "react";
import "./MainPageSub04_2graph.scss";

// const barData = [
//   { label: "동기부여", score: 90 },
//   { label: "목표의식", score: 80 },
//   { label: "독서력", score: 65 },
//   { label: "독해력", score: 53 },
//   { label: "어휘력", score: 50 },
//   { label: "표현력", score: 55 },
//   { label: "주도력", score: 75 }
// ];

const MainPageSub04_2graph = ({barData}) => {
  return (
    <div className="MainPageSub04_2graph">
      {barData.map((item, index) => (
        <div key={index} className="bar-container">
          <span className="label">{item.label}</span>
          <div className="bar">
            <div className="fill" style={{ width: `${item.score}%` }}>
              <span className="score">{item.score}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MainPageSub04_2graph;
